// extracted by mini-css-extract-plugin
export default {"container":"RecentListings_container__sAsfE"};